import { all } from 'redux-saga/effects';
import getUserDeatils from './otpVerificationDetails/saga';

export default function* rootSaga(getState) {
    yield all([
        getUserDeatils
    ]);
}
